module.exports = __webpack_public_path__ + "img/login-logo.e15ea26f.png";